<template>
  <v-row>
    <v-col cols="12" v-if="$store.state.subscriptions.retrieveLoader">
      <v-boilerplate type="table-heading, list-item-two-line" />
      <v-skeleton-loader class="mt-5" transition="fade-transition" type="table" />
    </v-col>
    <v-col cols="12" v-else>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <v-row align="center" justify="start" no-gutters>
              <router-link :to="{name: 'ProductListCreate'}" class="subtitle-1 routerLink font-weight-medium">Productos</router-link>
              <v-icon class="mx-1 pt-1" color="secondary">mdi-chevron-right</v-icon>
              <span class="subtitle-1 font-weight-medium d-inline-block text-truncate" :style="$vuetify.breakpoint.width < 1200 ? 'max-width: 200px;' : 'max-width: 500px;'">{{instance.name}}</span>
            </v-row>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="mr-1" @click="dialogProduct=true" outlined retain-focus-on-click color="secondary">Editar</v-btn>
              <v-menu close-on-click close-on-content-click left offset-y :nudge-bottom="10" transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ml-2" v-bind="attrs" v-on="on" min-width="34" max-width="34" color="secondary" outlined retain-focus-on-click><v-icon color="secondary">mdi-dots-horizontal</v-icon></v-btn>
                </template>
                <v-list class="pa-0">
                  <v-list-item class="px-5 py-1" @click="checkPlans">
                    <v-list-item-title class="subtitle-2 red--text font-weight-medium">Eliminar producto</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0 background">
          <v-row>
            <v-col md="6">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title>Nombre</v-list-item-title>
                  <v-list-item-subtitle>{{instance.name}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Etiqueta de unidad</v-list-item-title>
                  <v-list-item-subtitle>{{instance.unit_label}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>ID</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-tooltip right transition="scale-transition">
                      <template v-slot:activator="{on}">
                        <v-btn class="font-weight-regular" @click="toClipboard(instance.id)" text color="secondary" v-on="on" :ripple="false">{{instance.id}}</v-btn>
                      </template>
                      <span>Copiar</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Creado el</v-list-item-title>
                  <v-list-item-subtitle>{{instance.created | dateTime}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Actualizado el</v-list-item-title>
                  <v-list-item-subtitle>{{instance.updated | dateTime}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- pricing list -->
      <v-card class="mt-3">
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Planes de precios</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="pr-1">
              <v-btn class="mr-1" :to="{name: 'PlanCreate', query: {product: instance.id}}" outlined retain-focus-on-click color="secondary">Nuevo plan de precios</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0">
          <template v-if="!instance.plans.length">
            <v-col cols="12" class="text-center py-5">
              <v-icon class="d-block" color="secondary" size="70">mdi-calculator</v-icon>
              <span class="d-block subtitle-1">Crea un plan de precios para suscribir clientes a este producto</span>
              <v-btn class="my-5" :to="{name: 'PlanCreate', query: {product: instance.id}}" outlined color="secondary"><v-icon left>mdi-plus</v-icon>Crear un plan de precios</v-btn>
            </v-col>
          </template>
          <template v-else>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="width: 450px !important;" class="text-left">Plan</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="d in instance.plans">
                    <tr :key="d.id" @click="$router.push({name: 'PlanRetrieveUpdate', params: {id: d.id}})" style="cursor: pointer">
                      <td class="py-2">
                        <span class="text--secondary font-weight-medium">
                          {{d.name}}
                          <v-tooltip v-if="d.usage_scheme === 'metered'" right max-width="280px" transition="scale-transition">
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" small color="secondary">mdi-timelapse</v-icon>
                            </template>
                            <span>A los clientes suscritos a este plan se les facturará de acuerdo al consumo registrado para el periodo de facturación.</span>
                          </v-tooltip>
                        </span>
                        <div>
                          <span class="mr-1" v-if="d.tiers_mode">Desde</span>
                          <span class="text--secondary font-weight-medium">{{d.amount | number(d.currency.rounded)}}</span>
                          <span class="ml-1">{{d.currency.id}} / {{d.frequency.name}}</span>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </template>
        </v-card-text>
      </v-card>
      <!-- end pricing list -->
    </v-col>

    <!-- dialog product update -->
    <v-dialog v-model="dialogProduct" width="600" persistent no-click-animation scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Editar producto</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn class="ml-3" @click="dialogProduct=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-list class="v-list-form py-6 transparent">
            <v-list-item class="py-1">
              <v-list-item-title>
                Nombre
                <v-tooltip right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                  </template>
                  <span>Este nombre aparecerá en las futuras facturas.</span>
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field v-model="$v.editable.name.$model" :error="$v.editable.name.$error" background-color="white" outlined required single-line dense maxlength="80" placeholder="Escribe un nombre" hide-details />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>
                Unidad
                <v-tooltip right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                  </template>
                  <span>Representación de una unidad del producto, como un pase o una cuenta. Aparecerá en el campo de "unidad" de las facturas.</span>
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field v-model="$v.editable.unit_label.$model" :error="$v.editable.name.$error" background-color="white" outlined required single-line dense maxlength="12" hide-details />
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="dialogProduct=false" outlined color="secondary">Cancelar</v-btn>
          <v-btn @click="patchProduct" :loading="$store.state.subscriptions.createLoader" color="primary">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog product update -->

  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, maxLength } from 'vuelidate/lib/validators'
import GenericViewMixin from '@/mixins/GenericViewMixin'
export default {
  mixins: [
    GenericViewMixin
  ],
  inject: ['theme'],
  components: {
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  data: () => ({
    active: false,
    dialogProduct: false
  }),
  computed: mapState({
    account: state => state.auth.account.id,
    instance: state => state.subscriptions.productsDetail,
    editable: state => Object.assign({}, state.subscriptions.productsDetail)
  }),
  created () {
    this.$store.dispatch('subscriptions/RETRIEVE', {
      resource: 'products',
      id: this.$route.params.id
    })
  },
  methods: {
    patchProduct () {
      this.$v.editable.$touch()
      if (this.$v.editable.$invalid) {
        return false
      }
      const payload = {
        name: this.editable.name,
        unit_label: this.editable.unit_label
      }
      this.$store.dispatch('subscriptions/UPDATE', {
        resource: 'products',
        id: this.$route.params.id,
        payload: payload
      })
      .then(() => {
        this.dialogProduct = false
      })
    },
    checkPlans () {
      const activePlans = this.instance.plans.filter(plan => plan.status)
      if (activePlans.length) {
        this.active = true
        this.$dialog.warning({
          title: 'El producto no se puede eliminar',
          text: `
            <span class="d-block mb-4">Los productos con planes activos no se pueden eliminar. Si quieres eliminar este producto, primero elimina todos sus planes.</span>
          `,
          actions: [{
            color: 'red',
            text: 'Continuar'
          }]
        })
      } else {
        this.deleteProduct()
      }
    },
    deleteProduct () {
      this.$dialog.warning({
        title: 'Eliminar producto',
        text: `
          <span class="d-block mb-4">Al eliminar este producto, no podrás crear nuevos planes con él. Las suscripciones activas no serán afectadas y se seguirán facturando hasta que caduquen o se eliminen.</span>
          <span class="d-block my-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
             this.$store.dispatch('subscriptions/DESTROY', {
                resource: 'products',
                id: this.instance.id
              })
              .then(() => {
                this.$dialog.message.info('El producto ha sido eliminado')
                this.$router.push({
                  name: 'ProductListCreate',
                  params: {
                    id: this.editable.id
                  }
                })
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    }
  },
  validations: {
    editable: {
      name: {
        required,
        maxLength: maxLength(80)
      },
      unit_label: {
        required,
        maxLength: maxLength(12)
      }
    }
  }
}
</script>